<template>
  <div>
    <div
      v-for="(message, i) in messages"
      :key="i"
      class="pega-sent-message"
      :class="{'pega-recieved-message': message.fromOthers}"
      :data-test="`message-${i}`"
    >
      <div class="boss-message-header-layout boss-message-mail-subject">
        <span data-test="send-date">{{ message.sendDate }}</span>
        <div class="boss-layout-block boss-message-when">
          差出人：<span data-test="sender-name">{{ message.senderInfo.name }}</span>
          <span
            v-if="message.senderInfo.email"
            data-test="semder-email"
          >（{{ message.senderInfo.email }}）</span>
        </div>
      </div>
      <div class="boss-layout-block">
        <div
          class="pega-pre-wrap pega-break"
          data-test="message-body"
          v-html="$sanitize(renderBody(message.body))"
        />
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/lib/util'

export default {
  props: {
    messages: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    renderBody (body) {
      return util.replaceAddressAndUrlLink(body)
    }
  }
}
</script>
